import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'
import { Field } from 'redux-form'
import styles from './_cardNumberField.css'
import fieldProps from 'components/forms/fieldProps'
import FieldLabel from 'components/forms/FieldLabel'
import FieldError from 'components/forms/FieldError'
import { FormattedMessage } from 'react-intl'
import Svg from 'components/util/Svg'

const CARD_NUMBER_PATTERNS = {
  'american-express': [4, 6, 5],
  'visa': [4, 4, 4, 4],
  'mastercard': [4, 4, 4, 4],
  'discover': [4, 4, 4, 4],
  'diners-club': [4, 4, 4, 2],
  'jcb': [4, 4, 4, 4],
  'unknown': [4, 4, 4, 4],
}

export class CardNumberField extends Component {

  static propTypes = {
    ...fieldProps,
  }

  state = {
    cardType: 'unknown',
    displayNumber: '',
    number: '',
  }

  handleChange = (evt) => {
    const { input } = this.props
    const { target: { value }} = evt
    const type = this.getCardType(value)
    const displayNumber = this.getFormattedNumber(value, type)

    this.setState({ cardType: type, displayNumber }, () => {
      input.onChange(value.replace(/\s+/, ''))
    })
  }

  getFormattedNumber = (number, _type, last4 = false) => {
    if (!(_type in CARD_NUMBER_PATTERNS)) { return number }

    const pattern = CARD_NUMBER_PATTERNS[_type]

    let n = number.toString().replace(/\s+/, '')

    // strip all but numbers from input value
    if (!last4) { n = n.replace(/[^0-9]/, '') }

    // loops over the cc string, each time pulling out n-digits
    // and pushing them into an array like ['4242', '4242', etc...]
    const { parts } = pattern.reduce((prev, digits) => {
      const index = prev.index
      const newIndex = prev.index + digits
      const rest = n.substring(index)
      const regex = new RegExp(last4 ? `\\S{1,${digits}}` : `\\d{1,${digits}}`)
      const match = rest.match(regex)
      const newParts = !match ? prev.parts : prev.parts.concat(match[0])
      return { parts: newParts, index: newIndex }
    }, { parts: [], index: 0 })

    return parts.join(' ')
  }

  getFormattedLast4 = (last4, brand) => {
    const type = brand.toLowerCase().replace(' ', '-')
    const pattern = CARD_NUMBER_PATTERNS[type]
    const digits = pattern.reduce((prev, curr) => curr + prev, 0)
    const stars = Array(digits - 4).fill('*').join('')
    return this.getFormattedNumber(stars + last4, type, true)
  }

  getCardType = (number) => {
    if (!number) { return 'unknown' }
    return Stripe.cardType(number)
      .toLowerCase()
      .replace(' ', '-')
  }

  getValue = () => {
    const { mode, last4, brand } = this.props
    const { displayNumber } = this.state

    if (mode === 'create') { return displayNumber }
    return this.getFormattedLast4(last4, brand, true)
  }

  render () {
    const {
      input,
      name,
      label,
      disabled,
      editing,
      defaultProfile,
      meta: {
        touched,
        error,
      },
    } = this.props
    const showError = Boolean(touched && error)

    return (
      <label
        htmlFor={name}
        className={classnames(styles.container, {
          [styles.disabled]: disabled,
        })}
      >
        <FieldLabel required labelComponent={(
          <FormattedMessage
            id='premium.checkout.card_number'
            defaultMessage='Card number'
          />
        )} />

        <div className={styles.inputContainer}>
          <input
            {...input}
            id={name}
            value={this.getValue()}
            onChange={this.handleChange}
            type='text'
            disabled={disabled}
            className={classnames(styles.input, { [styles.error]: showError })}
          />
          <Svg
            className={styles.cardIcon}
            name={editing ? defaultProfile.cc_brand.toLowerCase() : this.state.cardType}
          />
        </div>

        <FieldError
          showError={showError}
          errorMessage={error}
          errorComponent={(
            <FormattedMessage
              id='premium.checkout.invalid_card'
              defaultMessage='Invalid card number'
            />
          )}
        />

      </label>
    )
  }

}

export const renderField = (field) => (
  <CardNumberField {...field} />
)

export const FieldWrapper = (props) => (
  <Field {...props} component={renderField} />
)

FieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.node,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
}

export default FieldWrapper
